import { IBudgetProgramAddEditRequest } from '../../../../model/sge/budget-program/request/budget-program-add-edit-request';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';

export type BudgetProgramField = 'budgetUnitId' | 'code' | 'name';

export function toBudgetProgramForm(data?: IBudgetProgramResponse): IBudgetProgramAddEditRequest {
    return data ? { budgetUnitId: data.budgetUnitId, code: data.code, name: data.name } : {};
}

export function validateBudgetProgram(form: IBudgetProgramAddEditRequest): ValidationErrors<BudgetProgramField> {
    const errors: ValidationErrors<BudgetProgramField> = {};
    if (isEmptyId(form.budgetUnitId)) errors.budgetUnitId = 'Unidade orçamentária é obrigatória';
    if (isBlank(form.code)) errors.code = 'Código é obrigatório';
    if (isBlank(form.name)) errors.name = 'Nome é obrigatório';
    return errors;
}
